import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Presence } from '../components/Presence';
import { DefaultAvatar } from './ProfilePage';
import { ClompApi } from '../api/ClompApi';
import { DiscordButton } from '../components/DiscordInvite';
import { TwitterButton } from '../components/TwitterButton';
import { RedditButton } from '../components/RedditButton';
import './AboutPage.css';

const api = new ClompApi();

// A founder's picture: their portrait from /img/founders (named after their username, in small letters) if there is
// one, otherwise the stand-in avatar every profile has
function FounderAvatar({ username }) {
    let [missing, setMissing] = React.useState(false);
    if (missing) {
        return <DefaultAvatar />;
    }
    return <img src={`/img/founders/${encodeURIComponent(username.toLowerCase())}.png`} alt="" onError={() => setMissing(true)} />;
}

export class AboutPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // the accounts with the Founder level, as their profiles show them; null until loaded
            founders: null
        }

    }

    componentDidMount() {
        api.profile.getFounders().then((data) => {
            this.setState({ founders: data.founders });
        }).catch((err) => {
            // the section is left out rather than shown empty
            console.log('Error loading founders: ', err);
            this.setState({ founders: [] });
        });
    }

    render() {
        let { founders } = this.state;
        return (
            <>
                <Navbar history={this.props.history}></Navbar>
                <div className="about-page">
                    <div className="about-page-header">
                        <h1>About</h1>
                    </div>
                    <div className="about-page-content">
                        <p>
                            Clomp is an online gaming platform that allows you to play and compete with other players.
                        </p>
                    </div>

                    {/* each Founder's card is their profile in small: picture, name, status and bio, linking to the profile */}
                    {founders === null || founders.length > 0 ?
                        <section className="about-founders">
                            <h2>Founders</h2>
                            <div className="about-founders-grid">
                                {(founders || []).map((founder) => (
                                    <Link className="about-founder" key={founder.id} to={`/profile/${encodeURIComponent(founder.username)}`}>
                                        <div className="about-founder-avatar" aria-hidden="true">
                                            <FounderAvatar username={founder.username} />
                                        </div>
                                        <div className="about-founder-body">
                                            <h3>{founder.username}</h3>
                                            <p className="about-founder-role">Founder</p>
                                            <Presence online={founder.online} lastSeen={founder.lastSeen} hidden={founder.presenceHidden} mine={founder.isMine} />
                                            {founder.bio ?
                                                <p className="about-founder-bio">{founder.bio}</p>
                                                :
                                                <p className="about-founder-bio about-founder-nobio">{founder.username} hasn't written a bio yet.</p>
                                            }
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </section>
                        : null}

                    <section className="about-community">
                        <h2>Community</h2>
                        <p>Chat with the team and other players, follow development, and tell us what you think.</p>
                        <div className="about-community-links">
                            <DiscordButton />
                            <TwitterButton />
                            <RedditButton />
                        </div>
                    </section>
                </div>
            </>
        );
    }
}
